import { API_URL_PATHS } from './server/ApiUrlPaths';
import { apiCall } from './server/ServerApi';
import { Logger } from './Logger';

const { PRODUCT_PLANS_URL_PATH } = API_URL_PATHS;

export const getProductPlanDisplayName = async (planId: string): Promise<string> => {
	let result = '';
	try {
		const plan = await apiCall('GET', `${PRODUCT_PLANS_URL_PATH}/${planId}`);
		result = plan.displayName;
	} catch (error) {
		Logger.error(error);
	}
	return result;
};
